"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitClientContext = InitClientContext;
function InitClientContext(type) {
    $(document).ready(function () {
        var model = new type();
        var context = document.getElementsByTagName("client-data");
        if (context.length === 1) {
            var json = context[0].innerHTML;
            var data = JSON.parse(json);
            $.extend(model, data);
        }
        model.Init();
    });
}
